import { useEffect, useRef, useState } from 'react'

import MainLoader from 'ageas-react-component-loader'
import Modal from 'ageas-react-component-modal'
import PageTitle from 'ageas-react-component-pagetitle'

import { SimulationNumberMain } from '../../GlobalStyles'
import { useReportStore } from '../../Stores/reportStore'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { t } from '../../i18n'
import { ModalComponent } from '../ModalComponent'
import { Tab } from '../Tab'
import { Documentation } from './Documentation'
import { Identification } from './Identification'
import { Container } from './styles'

type Props = {
  isVisible: boolean
  closeAction?: () => void
}

type TabProps = React.ElementRef<typeof Tab>

export const SimulationReport = ({ isVisible, closeAction }: Props) => {
  const { quoteId } = useSimulatorStore()
  const { isReportGeneratedEnabled } = useReportStore()
  const tabRef = useRef<TabProps>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!isReportGeneratedEnabled) {
      tabRef?.current?.handleNextStep()
    }
  }, [isReportGeneratedEnabled, tabRef])

  return (
    <ModalComponent show={isVisible}>
      <>
        <MainLoader show={isLoading} />
        <Modal
          show={isVisible}
          hideCloseAction={false}
          closeAction={closeAction}
          content={
            <Container>
              <PageTitle id="title" name={t('pages.step2.report.header')} />
              {(quoteId || '')?.length > 0 && (
                <SimulationNumberMain>
                  {t('pages.step2.report.headerAlt')} {quoteId}
                </SimulationNumberMain>
              )}
              <h4>{t('pages.step2.report.subHeader')}</h4>
              <div className="tab-container">
                <Tab
                  tabs={[
                    t('pages.step2.report.ownerIdentification'),
                    t('pages.step2.report.availableDocumentation'),
                  ]}
                  initialTab={isReportGeneratedEnabled ? 0 : 1}
                  disabledTabs={isReportGeneratedEnabled ? [1] : []}
                  ref={tabRef}
                  pages={[
                    <Identification
                      key="identification"
                      onLoading={setIsLoading}
                      fieldsDisabled={!isReportGeneratedEnabled}
                    />,
                    <Documentation
                      key="documentation"
                      onModalClose={closeAction}
                      onLoading={setIsLoading}
                    />,
                  ]}
                />
              </div>
            </Container>
          }
        />
      </>
    </ModalComponent>
  )
}
